import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FINAL_STEP_FOR_CAMPAIGN_LINK } from "../../constants/constants";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import client from "../../api";
import { notifyError, notifySuccess } from "../../helper";
import BlockLoader from "../BlockLoader";


const OptionsForCampaign = () => {
    const api = client();
    const {campaignID} = useParams('');
    const [campaignPreview,setCampaignPreview] = useState({});
    const [campaignOptions,setCampaignOptions] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading]=useState(false);
    const handleNextClick = async () => {
        try{
            setLoading(true);
            const response = await api.post('/v1/campaign/setting/update',{
                campaign_id: campaignID,
                setting: {
                    track_open: campaignPreview?.message_mime_type === 'text/html' ?  campaignOptions.track_open : false,
                    track_clicks: campaignPreview?.message_mime_type === 'text/html' ? campaignOptions.track_clicks : false,
                    schedule_send: campaignOptions.schedule_send,
                    pertinent_laws: campaignOptions.pertinent_laws
                },
                current_tab: "send",
                completed_tabs: ["start", "add-recipients", "compose", "options" ,"preview"]
            });
            if(response.status === 200 || response.status === 201){
                setLoading(false);
                notifySuccess('Campaign Options updated successfully.')
            }
        } catch(error){
            setLoading(false);
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Not able to update campaign options');
        }
        setTimeout(() => {
            if(campaignID){
                window.location.href = FINAL_STEP_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignID);    
            } else {
                notifyError('Campaign ID is missing');
            }
        }, 1500);
        
    }
    const handleOptionCheckbox = (obj) => {
        setCampaignOptions({...campaignOptions,...obj});
    }
    useEffect(()=>{
        const getCampaignOptions = async () => {
            try{
                const response = await api.post('/v1/campaign/setting/get',{
                    campaignID:campaignID
                });

                if(response.status === 200 || response.status === 201){
                    setCampaignOptions(response.data.data.setting);
                    setPageLoading(false);
                }

            } catch(error){
                console.log('error.message',error);
                setPageLoading(false);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Options.');
            } finally {
                setPageLoading(false);
            }
        }
        getCampaignOptions();
    },[]);
    
    useEffect(()=>{
        const getCampaignPreview = async () => {
            try{
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setCampaignPreview(response.data.campaignPreview);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        getCampaignPreview();
    },[]);

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
           <div className="campaign-create-steps">
            <div className="top-section">
                <h1>Add Campaign </h1>                
            </div>
                <div className="steps-wrap">
                    <Tabs currentTab="options" completedTabs={campaignPreview.completed_tab} />
                    
                    {pageLoading ? <div className="options-step"> <BlockLoader/> </div> : <div className="options-step">
                        <h3>How your campaign will be sent</h3>
                        <ul className="step-forms">
                            <li>
                                <input 
                                    type="checkbox" 
                                    name="track_open"
                                    checked={campaignPreview?.message_mime_type === 'text/plain' ? false : (Object.keys(campaignOptions).length && campaignOptions.track_open)}
                                    value={'Track opens'}
                                    disabled = { campaignPreview?.message_mime_type === 'text/plain' }
                                    onChange={(e)=>{
                                        handleOptionCheckbox({[e.target.name]:e.target.checked});
                                    }} /> Track opens
                            </li>
                            <li>
                                <input 
                                    type="checkbox" 
                                    name="track_clicks"
                                    checked={ campaignPreview?.message_mime_type === 'text/plain' ? false : (Object.keys(campaignOptions).length && campaignOptions.track_clicks)}
                                    value={'Track link clicks'}
                                    disabled = { campaignPreview?.message_mime_type === 'text/plain' }
                                    onChange={(e)=>{
                                        handleOptionCheckbox({[e.target.name]:e.target.checked});
                                    }} /> Track link clicks
                            </li>
                            {/* <li>
                                <input 
                                    type="checkbox" 
                                    name="schedule_send"
                                    checked={Object.keys(campaignOptions).length && campaignOptions.schedule_send}
                                    value={'schedule this send'}
                                    onChange={(e)=>{
                                        handleOptionCheckbox({[e.target.name]:e.target.checked});
                                    }} /> schedule this send
                            </li> */}
                            <li>
                                <input 
                                    type="checkbox"
                                    name="pertinent_laws"
                                    readOnly = {true}
                                    checked={Object.keys(campaignOptions).length && campaignOptions.pertinent_laws} 
                                    value={"I'll obey pertinent laws and I've read these important notes"}
                                    onChange={(e)=>{
                                        //handleOptionCheckbox({[e.target.name]:e.target.checked});
                                    }} /> I'll obey pertinent laws and I've read these important notes
                            </li>
                        </ul>
                        <button 
                            className={loading ? "primary-btn button--loading":"primary-btn"} 
                            disabled={loading}
                            onClick={()=>{
                                handleNextClick()
                            }}><span className="button--text">Next</span></button>
                    </div>}                    
                </div>
           </div>            
        </div>
        <Footer/>
    </>);
}

export default OptionsForCampaign;